import { CommonModule } from '@angular/common';
import {
  Component,
  DestroyRef,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
  inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { map, Observable, startWith } from 'rxjs';
import { CommonService } from '../../services/common.service';
import { DeviceService } from '../../services/device-service/device.service';
import { ToastrService } from 'ngx-toastr';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { Router, RouterLink } from '@angular/router';
import { ConfirmUpdateDeviceConfigurationComponent } from '../../Dialogs/confirm-update-device-configuration/confirm-update-device-configuration.component';
import { MatDialog } from '@angular/material/dialog';
import { CanComponentDeactivate } from '../../guards/unsaved-changes.guard';
import { UnsavedChangesTrackerService } from '../../services/unsaved-changes/unsaved-changes-tracker.service';
import { UnsavedChangesHostHelper } from '../../services/unsaved-changes/unsaved-changes-host.helper';
import { UNSAVED_FORM_DIALOG_OPTIONS } from '../../services/unsaved-changes/unsaved-form-dialog.options';
import {
  CUSTOMER_DROPDOWN_SELECT_LABEL,
  getGroupDropdownEmptyLabel,
  hasConcreteCustomerSelected,
  isGroupDropdownDisabled,
} from '../../services/group-dropdown.util';

const OTA_UPLOAD_DIRTY_SOURCE = 'ota-upload-configuration';

@Component({
  selector: 'app-upload',
  standalone: true,
  imports: [ CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatInputModule,
    RouterLink,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule],
  templateUrl: './upload.component.html',
  styleUrl: './upload.component.scss'
})
export class UploadComponent implements OnInit, OnDestroy, CanComponentDeactivate {
  customerControl = new FormControl();
  customers: any[] = [];
  groups: any[] = [];
  groupsLoaded = true;
  filteredCustomers: Observable<any[]> | undefined;
  groupControl = new FormControl({ value: '', disabled: true });
  filteredGroups!: Observable<any[]>;
  otaResponse:any[] =[];
  selectedCustomerName: any;
  selectedGroupName: any;
  groupDropdownEmptyLabel = 'Select a customer first';
  readonly customerDropdownSelectLabel = CUSTOMER_DROPDOWN_SELECT_LABEL;

  @ViewChild('fileInput', { static: true })
  fileInput!: ElementRef<HTMLInputElement>;
  selectedCustomer!: any;
  customerName: any;

  

  // groups: any;
  groupName!: string;
  selectedGroup: any;
  borderColor!: string;
  successCount!: number;
  // uploadText!: string;
  uploadText =
    'Please select the binary file for the configuration you wish to upload';
  fileToUpload: File | null = null;
  isFileUploaded!: boolean;
  showUploadButton: boolean = true;
  // customers: any;
  config:String ='';
  deviceConfigUpdateDTO = {
    configVersion: null as number | null,
    customerId: '',
    groupId: '',
  };

  private readonly destroyRef = inject(DestroyRef);
  private readonly unsavedChanges = inject(UnsavedChangesTrackerService);
  private readonly unsavedHost = new UnsavedChangesHostHelper(
    this.unsavedChanges,
    inject(MatDialog),
    inject(Router)
  );

  constructor(
    public commonService: CommonService,
    public deviceService: DeviceService,
    public toaster: ToastrService,
    private dialog: MatDialog,
    public router:Router
  ) {}
  ngOnInit(): void {
    this.fetchCustomers();
    this.initializeGroupFiltering();
    this.unsavedChanges.discardRequested$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.clearFormState());
  }

  ngOnDestroy(): void {
    this.unsavedHost.clearOnDestroy();
  }

  canDeactivate(): Promise<boolean> {
    return this.unsavedHost.canDeactivate();
  }

  @HostListener('window:beforeunload', ['$event'])
  onWindowBeforeUnload(event: BeforeUnloadEvent): void {
    this.unsavedHost.onBeforeUnload(event);
  }

  private hasUnsavedFormInput(): boolean {
    return (
      !!this.selectedCustomer ||
      !!this.selectedGroup ||
      !!this.fileToUpload
    );
  }

  private syncUnsavedChangesState(): void {
    this.unsavedChanges.setDirty(
      OTA_UPLOAD_DIRTY_SOURCE,
      this.hasUnsavedFormInput()
    );
  }

  private refreshGroupDropdownState(): void {
    const hasCustomer = hasConcreteCustomerSelected(this.selectedCustomer);
    const count = this.groups?.length ?? 0;
    this.groupDropdownEmptyLabel = getGroupDropdownEmptyLabel(
      hasCustomer,
      count,
      this.groupsLoaded
    );
    const disabled = isGroupDropdownDisabled(hasCustomer, count, this.groupsLoaded);
    if (disabled) {
      this.groupControl.disable({ emitEvent: false });
    } else {
      this.groupControl.enable({ emitEvent: false });
    }
  }

  private clearFormState(): void {
    this.customerControl.reset();
    this.groupControl.reset();
    this.groups = [];
    this.groupsLoaded = true;
    this.groupControl.disable();
    this.selectedCustomer = null;
    this.selectedCustomerName = '';
    this.selectedGroup = null;
    this.selectedGroupName = '';
    this.groupName = '';
    this.deviceConfigUpdateDTO = {
      configVersion: null,
      customerId: '',
      groupId: '',
    };
    this.uploadText =
      'Please select the binary file for the configuration you wish to upload';
    this.fileToUpload = null;
    this.isFileUploaded = false;
    this.borderColor = '#e5e5e5';
    if (this.fileInput?.nativeElement) {
      this.fileInput.nativeElement.value = '';
    }
    this.unsavedChanges.clear(OTA_UPLOAD_DIRTY_SOURCE);
    this.refreshGroupDropdownState();
  }

  // getConfigVersion(val: any) {
  //   this.deviceConfigUpdateDTO.configVersion = val.target.value;
  // }

//   getConfigVersion(event: any): void {
//   const value = event.target.value?.trim();
//   if (value && isNaN(Number(value))) {
//     this.toaster.warning('Please enter a valid numeric Config Version.');
//   } else {
//     this.deviceConfigUpdateDTO.configVersion = value;
//   }
// }




  navigateToOta(): void {
    this.commonService.reloadComponent();
  }
  fetchCustomers(): void {
    const payload = {
      page: 0,
      size: 500,
      filters: [
        {
          field: 'customerName',
          operator: '',
          value: '',
        },
      ],
      sorts: [
        {
          field: 'customerName',
          direction: 'asc',
        },
      ],
    };

    this.deviceService.getCustomerList(payload).subscribe({
      next: (response: any) => {
        this.customers = response?.data?.content ?? []; // Safe navigation and fallback
        this.initializeFiltering();
      },
      error: (error) => {
        console.error('Error fetching customers:', error);
      },
    });
  }

  onCustomerChange(event: any) {
    this.selectedCustomer = event.option.value.id;
    this.selectedCustomerName = event.option.value.customerName;
    this.deviceConfigUpdateDTO.customerId = this.selectedCustomer;
    this.groups = [];
    this.groupControl.setValue('');
    this.selectedGroup = null;
    this.selectedGroupName = '';
    this.groupName = '';
    this.deviceConfigUpdateDTO.groupId = '';
    if (!this.selectedCustomer) {
      this.groupsLoaded = true;
      this.refreshGroupDropdownState();
      this.syncUnsavedChangesState();
      return;
    }
    this.groupsLoaded = false;
    this.refreshGroupDropdownState();
    this.deviceService.getOtagroupIdList(this.selectedCustomer).subscribe({
      next: (response: any) => {
        this.groups = response?.data?.content ?? []; // Safe navigation and fallback
        this.groupsLoaded = true;
        this.selectedGroup = null;
        this.selectedGroupName = '';
        this.groupName = '';
        this.deviceConfigUpdateDTO.groupId = '';
        this.groupControl.setValue('');
        this.initializeGroupFiltering();
        this.refreshGroupDropdownState();
      },
      error: (error) => console.error('Error fetching groups:', error),
    });
    this.syncUnsavedChangesState();
  }

  initializeFiltering() {
    this.filteredCustomers = this.customerControl.valueChanges.pipe(
      startWith(''),
      map((value) => {
        if (!value) {
          // Clear groups when customer is emptied
          this.groups = [];
          this.filteredGroups = new Observable<any[]>(subscriber => subscriber.next([]));
          this.groupControl.setValue('');
          this.groupControl.disable();
          this.selectedCustomer = '';
          this.selectedGroup = null;
          this.selectedGroupName = '';
          this.deviceConfigUpdateDTO.customerId = '';
          this.deviceConfigUpdateDTO.groupId = '';
          this.groupsLoaded = true;
          this.refreshGroupDropdownState();
          this.syncUnsavedChangesState();
        }
        return typeof value == 'string' ? value : value?.customerName;
      }),
      map((name) => (name ? this._filter(name) : this.customers.slice()))
    );
  }

  private _filter(name: string): any[] {
    const filterValue = (name.toString()).toLowerCase(); // Convert input to lowercase for case-insensitive search
    return this.customers.filter((customer) =>
      customer.customerName.toLowerCase().includes(filterValue)
    );
  }
  displayFn(customer: any): string {
    return customer && customer.customerName ? customer.customerName : '';
  }

  initializeGroupFiltering() {
    this.filteredGroups = this.groupControl.valueChanges.pipe(
      startWith(''),
      map((value) => (typeof value === 'string' ? value : value)),
      map((name) => (name ? this._filterGroups(name) : this.groups.slice()))
    );
  }

  resetForm() {
    this.clearFormState();
    this.toaster.info('BIN file upload canceled.');
  }


readBinFileMetadata(file: File) {
  const reader = new FileReader();
  reader.onload = () => {
    const arrayBuffer = reader.result as ArrayBuffer;
    const dataView = new DataView(arrayBuffer);
    const configVersion = dataView.getUint32(0x0C, true); // little endian
    const fwVersion = dataView.getUint32(0x38, true);     // little endian
    this.deviceConfigUpdateDTO.configVersion = configVersion;
    console.log('Config Version:', configVersion);
    console.log('FW Version:', fwVersion);
    if(configVersion == null || configVersion == undefined){
      this.toaster.error('Please Upload valid BIN file.');return;
    }else{
      // Open confirmation dialog here, passing values
      const dialogRef = this.dialog.open(ConfirmUpdateDeviceConfigurationComponent, {
        width: '600px',
        ...UNSAVED_FORM_DIALOG_OPTIONS,
        data: {
          customer: this.selectedCustomerName,
          group: this.selectedGroupName,
          configVersion,
          fwVersion,
          file: this.fileToUpload
        }
      });
      this.syncUnsavedChangesState();

      dialogRef.afterClosed().subscribe((result) => {
        if (result === 'publish') {
          this.uploadFile(); // 🔁 Trigger upload if user clicked OK
        }else{
          this.resetForm(); 
        }
      });
    }
    

  };
  reader.readAsArrayBuffer(file);
}


  private _filterGroups(name: string): any[] {
    const filterValue = (name.toString()).toLowerCase();  // Convert search term to lowercase
    return this.groups.filter((group) =>
      group.groupName.toLowerCase().includes(filterValue)  // Convert group name to lowercase for comparison
    );
  }
  displayGroupFn(group: any): string {
    return group && group.groupName ? group.groupName : '';
  }
  onGroupChange(event: any) {
    this.selectedGroup = event.option.value.id;
    this.selectedGroupName = event.option.value.groupName;
    this.deviceConfigUpdateDTO.groupId = this.selectedGroup;
    this.syncUnsavedChangesState();
  }

  triggerFileInput() {
    this.fileInput?.nativeElement.click();
  }
  onDragOver(event: DragEvent) {
    event.preventDefault();
    this.borderColor = '#ff6b35';
  }
  onDragLeave() {
    this.borderColor = '#e5e5e5';
  }
  /* 
  -------------------
  OLD function
  -------------------

  onFileDrop(event: DragEvent) {
    this.successCount = 0;
    event.preventDefault();
    this.borderColor = '#e5e5e5';

    const files = event.dataTransfer?.files;
    console.log(files);
    this.uploadText = `Selected file: ${files?.item(0)?.name}`;
    if (files?.length) {
      let extension = this.uploadText.split('.').pop();
      if (extension == 'bin') {
        this.fileToUpload = files[0];
        this.isFileUploaded = true;
      } else {
        this.toaster.error('Upload Binary file format', 'Failed');
      }
    }
  } 
  */  
  onFileDrop(event: DragEvent) {
  this.successCount = 0;
  event.preventDefault();
  this.borderColor = '#e5e5e5';

  const files = event.dataTransfer?.files;
  this.uploadText = `Selected file: ${files?.item(0)?.name}`;
  if (files?.length) {
    const extension = this.uploadText.split('.').pop();
    if (extension === 'bin') {
      this.fileToUpload = files[0];
      this.isFileUploaded = true;
      this.syncUnsavedChangesState();
      this.readBinFileMetadata(this.fileToUpload); // 🟡 Call added
    } else {
      this.toaster.error('Upload Binary file format', 'Failed');
      this.syncUnsavedChangesState();
    }
  }
}

/* 
  -------------------
  OLD function
  -------------------
  onFileInputChange(event: any): void {
    const files: FileList = event.target.files;

    if (files && files.length > 0) {
      this.uploadText = files[0].name;
      let extension = this.uploadText.split('.').pop();
      console.log(extension);
      if (extension == 'bin') {
        this.fileToUpload = files[0];
        console.log(this.fileToUpload.name);
        this.isFileUploaded = true;
      } else {
        this.fileToUpload = null;
        this.isFileUploaded = false;
        this.toaster.error('Upload binary file format', 'Failed');
      }
    }
  }
   
  */

  onFileInputChange(event: any): void {
  const files: FileList = event.target.files;

  if (files && files.length > 0) {
    this.uploadText = files[0].name;
    const extension = this.uploadText.split('.').pop();

    if (extension === 'bin') {
      this.fileToUpload = files[0];
      this.isFileUploaded = true;
      this.syncUnsavedChangesState();
      this.readBinFileMetadata(this.fileToUpload); // 🟡 Call added
    } else {
      this.fileToUpload = null;
      this.isFileUploaded = false;
      this.toaster.error('Upload binary file format', 'Failed');
      this.syncUnsavedChangesState();
    }
  }
}


  uploadFile() {
    if (!this.fileToUpload || !(this.deviceConfigUpdateDTO.customerId && this.deviceConfigUpdateDTO.groupId)) {
      this.toaster.warning(
        'Please select all fields and a file before uploading.'
      );
      return;
    }
    if (this.fileToUpload) {
      const formData = new FormData();
      formData.append('file', this.fileToUpload);

      // Append JSON object as a string
      formData.append(
        'deviceConfigUpdateDTO',
        // JSON.stringify(this.deviceConfigUpdateDTO)
        new Blob([JSON.stringify(this.deviceConfigUpdateDTO)], {
          type: 'application/json',
        })
      );
      this.deviceService.uploadOta(formData).subscribe({
        next: (response:any) => {
          this.otaResponse = response;
          this.toaster.success('File uploaded successfully!',"success");
          // Clear before navigate so canDeactivate does not block leave.
          this.unsavedChanges.clear(OTA_UPLOAD_DIRTY_SOURCE);
          this.router.navigate(['ota/device-configuration-list']);
          console.log('ota response', response);
        },
        error: (err: any) => {
          console.log('ota err', err);
          const errorMsg = err?.error?.message || 'Something went wrong while uploading.';
          this.toaster.error(errorMsg, 'Error', {
            toastClass: 'ngx-toastr custom-toast-width'
          });
          this.resetForm(); 
        },
      });
    }
  }
}
